export default __webpack_public_path__ + "static/keyboard-703f0f1f5dfd6474bd2edfc043eb2cf0.png";